import { mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters('user', ['userReady', 'userToken']),
		isUserLoaded() {
			return this.userReady && this.userToken;
		}
	}
};
